{
  "_provenance": {
    "ns": "shell",
    "source": "src/components/layout/*, src/pages/NotFoundPage.tsx and the chrome they mount: landing/StevensTopbar + StevensFooter (AuthShell), editorial/BackLink + ThemeToggle, notifications/NotificationPanel, a11y/SkipToContent"
  },
  "a11y": {
    "skipToContent": "Skip to content"
  },
  "authShell": {
    "document": "Document"
  },
  "bottomNav": {
    "openMenu": "Open menu",
    "primaryNavigation": "Primary navigation"
  },
  "header": {
    "backTo": "Back to {{label}}",
    "openMenu": "Open menu",
    "openProfile": "Open profile",
    "profile": "Profile",
    "profileNamed": "Profile — {{name}}",
    "sendFeedback": "Send feedback",
    "signOut": "Sign out",
    "theme": {
      "dark": "dark",
      "light": "light",
      "system": "system"
    },
    "themeAria": "Theme: {{current}}. Switch to {{next}}.",
    "themeSwitch": "Switch to {{next}} mode"
  },
  "helpFab": {
    "label": "Help"
  },
  "impersonation": {
    "banner": "Impersonating <strong>{{name}}</strong> ({{email}}) as {{actor}}",
    "stop": "Stop Impersonating"
  },
  "legal": {
    "all": "All legal",
    "cookies": "Cookies",
    "landmark": "Legal links",
    "privacy": "Privacy",
    "sms": "SMS",
    "terms": "Terms"
  },
  "notFound": {
    "backHome": "Back to home",
    "lede": "The link may be stale or mistyped — nothing on your side is lost.",
    "title": "This address goes <em>nowhere</em>."
  },
  "notifications": {
    "empty": "No notifications yet",
    "loadError": "We couldn’t load your notifications. Try again in a moment.",
    "markAllRead": "Mark all read",
    "title": "Notifications",
    "titleWithCount_one": "Notifications, {{count}} unread",
    "titleWithCount_other": "Notifications, {{count}} unread"
  },
  "profileRow": {
    "account": "Account",
    "active": "active",
    "open": "Open profile — {{name}} · {{role}}"
  },
  "publicChrome": {
    "apply": "Apply →",
    "footer": {
      "allLegal": "All legal documents",
      "builtWithCare": "Built with care for families.",
      "cookiePolicy": "Cookie Policy",
      "copyright": "© {{year}} {{org}}. All rights reserved.",
      "donate": "Donate",
      "faq": "FAQ",
      "forgotPassword": "Forgot password",
      "foundation": "Foundation",
      "legal": "Legal",
      "ourMission": "Our Mission",
      "platform": "Platform",
      "privacyPolicy": "Privacy Policy",
      "smsTerms": "SMS Terms",
      "tagline": "A 24/7 assistant for families navigating pediatric cancer.",
      "termsOfService": "Terms of Service",
      "trustAndPrivacy": "Trust and privacy",
      "tylersStory": "Tyler’s Story",
      "whatsInside": "What’s inside"
    },
    "homeAria": "{{org}} home",
    "myAccount": "My account",
    "primaryNav": "Primary",
    "signedInAs": "Signed in as {{email}}",
    "signIn": "Sign in"
  },
  "roles": {
    "admin": "Admin",
    "applicant": "Applicant",
    "parent": "Parent",
    "trfer": "TRFer"
  },
  "roleSwitcher": {
    "active": "Active",
    "aria": "Switch role — currently {{role}}",
    "label": "Switch role",
    "tooltip": "Switch role · {{role}}"
  },
  "sidebar": {
    "closeMenu": "Close menu",
    "collapse": "Collapse sidebar",
    "expand": "Expand sidebar",
    "inGroup": "in {{group}}",
    "resize": "Resize {{target}}",
    "resizeTarget": "sidebar",
    "unread_one": "{{count}} unread",
    "unread_other": "{{count}} unread"
  },
  "themeToggle": {
    "aria": "Cycle theme. Current: {{current}}",
    "dark": "Dark theme",
    "light": "Light theme",
    "system": "System theme"
  },
  "unreadsBell": {
    "name": "Unreads",
    "nameWithCount_one": "Unreads, {{count}} unread",
    "nameWithCount_other": "Unreads, {{count}} unread"
  }
}
